import { useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetPipelineStatusList } from "@type/api/management";
import { useTranslationContext } from "context/TranslationContext";
import { getTranslationKey } from "helpers/getTranslationKey";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import { DEFAULT_VALUE } from "constants/index";

interface UseGetPipelineStatusOptionsParams {
  pipelineSlug?: string;
  language?: string;
}

export const useGetPipelineStatusOptions = ({
  pipelineSlug,
  language = DEFAULT_VALUE.LANGUAGE,
}: UseGetPipelineStatusOptionsParams) => {
  const { t } = useTranslationContext();
  const [pipelineStatusOptions, setPipelineStatusOptions] =
    useState<TInputTag[]>();

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetPipelineStatusList._key({ pipelineSlug }, language),
    enabled: !!pipelineSlug,
    queryFn: () => queryGetPipelineStatusList({ pipelineSlug }, language),
    onSuccess: (res) => {
      const pipelineStatusOptions: TInputTag[] = res.data.map(
        ({ id, name }) => ({
          id,
          name: t(getTranslationKey(name)),
        })
      );
      setPipelineStatusOptions(pipelineStatusOptions);
    },
  });

  return {
    isLoadingPipelineStatusOptions: isLoading,
    pipelineStatusOptions,
  };
};
